/* App Kaching REAL no [data-cl-app-slot="kaching"] do buybox (retrabalho 10-30, substitui a replica do Moonbundle).
   O ATC do buybox (product-form-component do Horizon) manda o lote do proprio app
   (kaching-bundles-block.items(): quantidade da barra, variantes de cada peca, __kaching_bundles) em
   /cart/add.js?kaching_bundles=true (o embed nao re-intercepta) e abre a nossa gaveta.
   Sem barras (app ainda carregando / produto sem deal): a variante atual x 1.
   Captura no WINDOW: o sistema de eventos declarativo do Horizon (on:click / on:submit) escuta no document. */
(function () {
  if (window.__clKachingApp) return;
  window.__clKachingApp = true;

  function hostFor(form) {
    var box = form && form.closest('.sl-buybox, .sl-qa-body, .slc-product, [data-cl-buybox]');
    return box && box.querySelector('[data-cl-app-slot="kaching"]');
  }

  function lot(form, slot) {
    var kb = slot.querySelector('kaching-bundles-block');
    if (kb && typeof kb.items === 'function') {
      try { var its = kb.items(); if (its && its.length) return its; } catch (e) {}
    }
    var idInput = form.querySelector('[name="id"]');
    var vid = idInput && Number(idInput.value);
    return vid ? [{ id: vid, quantity: 1 }] : [];
  }

  function sectionsParam() {
    var s = document.querySelector('[data-cl-drawer-section]');
    return s ? s.getAttribute('data-cl-drawer-section') : null;
  }

  function submit(form, slot, btn) {
    var list = lot(form, slot);
    if (!list.length) return;
    btn && btn.setAttribute('aria-busy', 'true');
    var body = { items: list };
    var sec = sectionsParam();
    if (sec) body.sections = sec;
    fetch('/cart/add.js?kaching_bundles=true', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn && btn.removeAttribute('aria-busy');
        if (!res.ok) {
          document.dispatchEvent(new CustomEvent('cl-cart:error', { detail: res.j }));
          if (typeof window.openMoonBundleCartDrawer === 'function') window.openMoonBundleCartDrawer(res.j && (res.j.description || res.j.message));
          return;
        }
        document.dispatchEvent(new CustomEvent('cl-cart:added', { detail: res.j }));
        if (typeof window.openMoonBundleCartDrawer === 'function') window.openMoonBundleCartDrawer(null, res.j && res.j.sections);
        else window.location.href = '/cart';
      }).catch(function () { btn && btn.removeAttribute('aria-busy'); form.submit(); });
  }

  function isAdd(form) {
    return form && /\/cart\/add/.test((form.getAttribute && form.getAttribute('action')) || '');
  }

  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[type=submit], [type=submit]');
    if (!b) return;
    var form = b.form || b.closest('form');
    if (!isAdd(form)) return;
    var slot = hostFor(form);
    if (!slot) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submit(form, slot, b);
  }, true);
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAdd(form)) return;
    var slot = hostFor(form);
    if (!slot) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submit(form, slot, form.querySelector('[type=submit]'));
  }, true);
})();
